module.exports = __webpack_public_path__ + "static/img/tab_top.8f302fc.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/keyboard-vue/dist/tab_top.png
// module id = Bx7r
// module chunks = 1